import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-616e8d76"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "title" }, "请输入验证码", -1); });
var _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 验证码已发送至您的手机号码 ");
var _hoisted_5 = { style: { color: '#000', fontWeight: 700 } };
var _hoisted_6 = { class: "submit-btn" };
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("登 录");
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast, Notify } from "vant";
import request from "@/provide/fetch";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VerificationCode',
    setup: function (__props) {
        var _this = this;
        var router = useRouter();
        var route = useRoute();
        var codeInputRef = ref();
        var code = ref("");
        var loading = ref(false);
        var count = ref(59);
        var countdown = function () {
            count.value = 59;
            var timer = setInterval(function () {
                if (count.value > 0) {
                    count.value--;
                }
                else {
                    timer && clearInterval(timer);
                    timer = null;
                }
            }, 1000);
        };
        var getSms = function () { return __awaiter(_this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, request({
                            url: "/api/user/send-sms",
                            method: "POST",
                            data: {
                                mobile: route.query.tel,
                                userType: localStorage.getItem("userType"),
                                openId: sessionStorage.getItem("openId"),
                            },
                        }).catch(function () {
                            Toast("网络错误-7");
                            loading.value = false;
                        })];
                    case 1:
                        resData = _a.sent();
                        loading.value = false;
                        if (resData.code === 200) {
                            // alert(`验证码： ${resData.message}`);
                            Toast("发送成功");
                            codeInputRef.value.focus();
                            countdown();
                        }
                        else {
                            Toast(resData.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getSms();
        var handleSummit = function (e, type) {
            if (type === void 0) { type = route.query.userType || 1; }
            return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!code.value) {
                                return [2 /*return*/, Notify("请填写验证码")];
                            }
                            loading.value = true;
                            return [4 /*yield*/, request({
                                    url: "/api/user/sign-in",
                                    method: "POST",
                                    data: {
                                        openId: sessionStorage.getItem("openId"),
                                        code: code.value,
                                        mobile: route.query.tel,
                                        userType: type,
                                        headImgUrl: sessionStorage.getItem("headImgUrl"),
                                    },
                                })];
                        case 1:
                            res = _a.sent();
                            loading.value = false;
                            if (res.code === 200) {
                                localStorage.setItem("token", res.data.token);
                                localStorage.setItem("userId", res.data.userId);
                                localStorage.setItem("userType", route.query.userType || "1");
                                switch (+type) {
                                    case 1:
                                        location.replace("/products");
                                        break;
                                    case 2:
                                        location.replace("/salesman-personal-center");
                                        break;
                                    case 3:
                                        location.replace("/doctor-list");
                                        break;
                                }
                            }
                            else {
                                Toast(res.message);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_cell_group = _resolveComponent("van-cell-group");
            var _component_van_button = _resolveComponent("van-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "验证码",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); }),
                    "left-arrow": ""
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("p", {
                        style: _normalizeStyle({ color: '#666', fontSize: '0.28rem' })
                    }, [
                        _hoisted_4,
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(route).query.tel), 1)
                    ], 4),
                    _createVNode(_component_van_cell_group, { border: false }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_van_field, {
                                ref_key: "codeInputRef",
                                ref: codeInputRef,
                                style: _normalizeStyle({
                                    marginTop: '1.6rem',
                                    marginBottom: '0.16rem',
                                    border: '2px solid #EEEEEE',
                                    borderRadius: '0.16rem',
                                }),
                                modelValue: code.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((code).value = $event); }),
                                maxlength: "4"
                            }, null, 8, ["style", "modelValue"])
                        ]; }),
                        _: 1
                    }),
                    (count.value > 0)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            style: _normalizeStyle({ fontSize: '0.28rem', fontWeight: 400, color: '#999' })
                        }, " 重新发送（" + _toDisplayString(count.value) + "s） ", 5))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            style: _normalizeStyle({ fontSize: '0.28rem', fontWeight: 400, color: '#3DABA4' }),
                            onClick: getSms
                        }, " 重新发送 ", 4)),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_van_button, {
                            loading: loading.value,
                            round: "",
                            block: "",
                            type: "primary",
                            color: "rgba(61,171,164,1)",
                            onClick: handleSummit
                        }, {
                            default: _withCtx(function () { return [
                                _hoisted_7
                            ]; }),
                            _: 1
                        }, 8, ["loading"])
                    ])
                ])
            ]));
        };
    }
});
